export default __webpack_public_path__ + "static/media/illustration-algocare-w@3x.24275327.webp";